import { render, staticRenderFns } from "./ProductsManager.vue?vue&type=template&id=16994e99&scoped=true&"
import script from "./ProductsManager.vue?vue&type=script&lang=js&"
export * from "./ProductsManager.vue?vue&type=script&lang=js&"
import style0 from "./ProductsManager.vue?vue&type=style&index=0&id=16994e99&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16994e99",
  null
  
)

export default component.exports